import { joinSearchFields, normalizeSearchText } from './searchText.js'
import { buildMemberSearchText } from './memberSearch.js'
import type { MemberSearchFields } from './memberSearch.js'

/**
 * Canonical SubKrewe matching. The member-search counterpart — see
 * memberSearch.ts — over the SubKrewe field set.
 */

export interface SubKreweSearchFields {
  name?: string | null
  description?: string | null
  /**
   * Captains, matched through the member field set. Admin surfaces let you
   * find a SubKrewe by who runs it; member-facing browsing does not, so this
   * is opt-in per call site rather than always populated.
   */
  captains?: MemberSearchFields[] | null
}

/** Build the blob a query is tested against for one SubKrewe. */
export function buildSubKreweSearchText(fields: SubKreweSearchFields): string {
  return joinSearchFields([
    normalizeSearchText(fields.name),
    normalizeSearchText(fields.description),
    ...(fields.captains ?? []).map(buildMemberSearchText),
  ])
}
